"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function RtmpSettings(_a) {
    var livestream = _a.livestream;
    var CopyRtmp = storybook_1.Hooks.useCopy('rtmp://global-live.mux.com:5222/app', 'icon')[0];
    var CopyRtmps = storybook_1.Hooks.useCopy(livestream.ingest, 'icon')[0];
    var CopyStreamKey = storybook_1.Hooks.useCopy(livestream.ingest_name, 'icon')[0];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Ingest informatie"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(storybook_1.Texts.Label, null, "RTMP URL"),
            react_1.default.createElement(CopyRtmp, null),
            react_1.default.createElement(storybook_1.Texts.Label, null, "RTMPS URL"),
            react_1.default.createElement(CopyRtmps, null)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(storybook_1.Texts.Label, null, "STREAM KEY"),
            react_1.default.createElement(CopyStreamKey, null)));
}
function Rtmp(_a) {
    var livestream = _a.livestream;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "RTMP stream"),
        react_1.default.createElement(storybook_1.Texts.Small, { className: 'mb-4' },
            "Voor een RTMP stream worden \u20AC4,90 incl btw aan kosten per uur voor cloud transcoding in rekening gebracht. Check je\u00A0",
            react_1.default.createElement(storybook_1.Texts.Link, { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/billing" }, "Billing dashboard"),
            "\u00A0voor een actueel overzicht."),
        livestream.id && react_1.default.createElement(RtmpSettings, { livestream: livestream }));
}
function IngestInformation(_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream;
    var isRtmp = livestream.type === 'rtmp';
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-livestreams-ingest-information' },
        react_1.default.createElement(storybook_1.Cards.Content, null, isRtmp ? react_1.default.createElement(Rtmp, { livestream: livestream }) : react_1.default.createElement(storybook_1.Livestreams.FormHls, { livestream: livestream, setLivestream: setLivestream })));
}
exports.default = IngestInformation;
IngestInformation.propTypes = {
    livestream: prop_types_1.default.object.isRequired,
};
